import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, sortSets, searchSets } from "../../actions/settings"
import { fetchRights, editRight } from "../../actions/rightActions"
import { addFlashMessage } from "../../actions/flashMessages"
import SettingsForm from './SettingsForm'

class SetsRight extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('action');
    this.props.fetchSets('atype');
    this.props.fetchRights();
    this.props.fetchSets('usrg');
  }

  modelName = 'action'

  handleChBox = (e, usrg_id, action_id) => {
    const check = e.target.checked ? 1 : 0;
    this.props.editRight({
      action_id,
      usrg_id,
      check
    }, err => {
      if (err) {
        this.props.addFlashMessage({type: 'error', text: err.form});
      }
    });
  }

  render() {
    if(isEmpty(this.props.actions.data)
      || isEmpty(this.props.atypes)
      || isEmpty(this.props.rights)
      || isEmpty(this.props.usrgs)
    ){
      return(<div>Не загружены данные</div>);
    }
    const {
      atypes,
      usrgs,
      rights,
      userRights,
      actions: {
        data: actions,
        search,
        sort
      }
    } = this.props;

    var fltrActions = [];
    for(var key in actions){
      if(
        actions.hasOwnProperty(key) &&
        (
          userRights.right_s_get || !actions[key].action_admin
        ) &&
        actions[key].action_atype_id !== 0 &&
        actions[key].action_atype_id !== 8
      ){
        var found = true;
        if(search !== ''){
          const searchValue = "" + actions[key].action_desc +
            actions[key].action_name;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(found){
          fltrActions.push(actions[key]);
        }
      }
    }

    const srtActions = fltrActions.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.action_id < b.action_id)
         return sort.asc ? -1 : 1
      if(a.action_id > b.action_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const groups = [];
    for (let usrgId in usrgs) {
      if (usrgs.hasOwnProperty(usrgId)) {
        groups.push(usrgs[usrgId]);
      }
    }

    const mappedActions = srtActions ? srtActions.map(action => {
      return (
        <tr key={action.action_id}>
          <td>{action.action_desc}</td>
          <td>{atypes[action.action_atype_id].atype_desc}</td>
          {groups.map(usrg => {
            return(
              <td key={usrg.usrg_id}>
                <input
                  type="checkbox"
                  checked={
                    !!rights[action.action_id] &&
                    (rights[action.action_id].indexOf(usrg.usrg_id) !== -1)
                  }
                  onChange={e => this.handleChBox(e, usrg.usrg_id, action.action_id)}
                />
              </td>
            );
          })}
        </tr>
      );
    }) : [];

    return (
      <div>
        <h3 className="pull-right">Настройка прав доступа</h3>
        <div className="form-group form-inline">
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrActions.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th
                className="col-sm-3"
                onClick={() => {this.handleSort('action_desc',this)}}
              >
                Действие
              </th>
              <th
                className="col-sm-2"
                onClick={() => {this.handleSort('action_atype_id',this)}}
              >
                Тип действия
              </th>
              {groups.map(usrg => {
                return(
                  <th
                    key={usrg.usrg_id}
                    title={usrg.usrg_desc}
                  >
                    {usrg.usrg_desc.slice(0,3)}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {mappedActions}
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    actions: store.actions,
    atypes: store.atypes.data,
    rights: store.rights.data,
    usrgs: store.usrgs.data,
    userRights: store.auth.rights
  }
}

export default connect(mapOrdersToProps, {
  fetchSets,
  editRight,
  sortSets,
  searchSets,
  fetchRights,
  addFlashMessage
})(SetsRight);



// WEBPACK FOOTER //
// ./src/components/settings/SetsRight.js